import { render, staticRenderFns } from "./EquipmentFitmentItemsTable.vue?vue&type=template&id=2bf7d0d1&scoped=true"
import script from "./EquipmentFitmentItemsTable.vue?vue&type=script&lang=ts"
export * from "./EquipmentFitmentItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentFitmentItemsTable.vue?vue&type=style&index=0&id=2bf7d0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7d0d1",
  null
  
)

export default component.exports